
import { useEffect } from "react";
import { usePagination } from "../usePagination";
import { countTotalPrompts } from "@/utils/exploreQueries";

interface UseExplorePaginationProps {
  totalItems: number | undefined;
  initialCategoriesLoaded: React.MutableRefObject<boolean>;
  selectedCategory: string | null;
  searchQuery: string;
}

export function useExplorePagination({
  totalItems,
  initialCategoriesLoaded,
  selectedCategory,
  searchQuery
}: UseExplorePaginationProps) {
  // Initialize pagination with default value for totalItems
  const { 
    currentPage, 
    setCurrentPage,
    totalPages,
    itemsPerPage: ITEMS_PER_PAGE,
    setTotalItems
  } = usePagination({ 
    totalItems: totalItems || 0,
    itemsPerPage: 9
  });

  // Update pagination when totalItems changes
  useEffect(() => {
    if (totalItems !== undefined) {
      console.log(`Updating pagination with ${totalItems} total items`);
      setTotalItems(totalItems);
    }
  }, [totalItems, setTotalItems]);

  // Load initial total count for all prompts if not set
  useEffect(() => {
    const loadInitialCount = async () => {
      if (!totalItems && initialCategoriesLoaded.current && !selectedCategory && !searchQuery) {
        try {
          console.log("Loading initial total prompt count");
          const count = await countTotalPrompts();
          console.log(`Initial total count loaded: ${count}`);
          setTotalItems(count);
        } catch (err) {
          console.error("Error loading initial count:", err);
        }
      }
    };
    
    loadInitialCount();
  }, [initialCategoriesLoaded.current, totalItems, selectedCategory, searchQuery, setTotalItems]);

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    ITEMS_PER_PAGE,
    setTotalItems
  };
}
